export const validName = (str) => str && str.length;
